import React from "react";
import { Link } from "react-router-dom";

function Org() {
  return (
    <div>
      <section
        className="page-title"
        style={{
          backgroundImage: "url(../images/background/bg-page-title-1.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>조직도</h1>
          <div className="bread-crumb-outer">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">조직도</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="featureStyle1">
        <div className="auto-container">
          <div className="row clearfix" style={{textAlign:'center', margin:'20px'}}>
              <img src="../images/nexmore/organization.png" alt="" style={{width:'100%', maxWidth:'900px'}}/>
          </div>
        </div>
      </section>
      <br />
    </div>
  );
}

export default Org;
